import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

export default function ImageContent(props) {

    const [ showFull, setShowFull ] = useState(false);
    const { t } = useTranslation();
    let curLang = localStorage.getItem('i18nextLng') === 'en' ? '' : 'ar';

    return (
        <>
            <Container>
                <Row>
                { showFull === false &&
                    <>
                        <Col xs={12}>
                            <h2 className={`title${curLang} fs-32 light-black fw-semi-bold mb-4`}>
                                {props.title}
                            </h2>
                            {props.content}
                            <Button variant="contained" color="primary" className={`green-btn${curLang}`} 
                                onClick={() => setShowFull(!showFull)}
                            >
                                {t('homepage.read-more')}
                            </Button>
                        </Col>
                    </>
                }
                    { showFull === true &&
                        <Col xs={12}>
                            <h2 className={`title${curLang} fs-32 light-black fw-semi-bold mb-4`}>
                                {props.title}
                            </h2>
                            {props.fullcontent}
                            <Button variant="contained" color="primary" className={`green-btn${curLang}`} 
                                onClick={() => setShowFull(!showFull)}
                            >
                                {t('homepage.read-less')}
                            </Button>
                        </Col>
                    }
                </Row>
            </Container>    
        </>
    )
}